import axios from "axios";
import DOMPurify from 'dompurify';
import { getB2BTokens, setB2BTokens } from "./userData";
import { getBaseUrlB2B } from "./BaseURLS";

const defaultOptions = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const axiosWithToken = axios.create(defaultOptions);

function sanitizeData(data) {
  if (data === null || data === undefined) return data;
  if (typeof data === 'string') {
    return DOMPurify.sanitize(data);
  } else if (Array.isArray(data)) {
    return data.map(sanitizeData);
  } else if (typeof data === 'object') {
    const sanitizedObject = {};
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        sanitizedObject[key] = sanitizeData(data[key]);
      }
    }
    return sanitizedObject;
  }
  return data;
}

axiosWithToken.interceptors.response.use(
  (response) => {
    if (response.config.responseType !== 'blob')
      response.data = sanitizeData(response.data);
    return response;
  },
  async function (error) {
    if (error.response?.status === 401) {
      const tokens = getB2BTokens();
      const payerToken = tokens[0];
      const payername = payerToken?.payerName;
      try {
        const refreshTokenResponse = await axios.post(`${getBaseUrlB2B()}/provider/auth/refresh-token`, {
          refreshToken: payerToken?.refreshToken,
        }, {
          headers: {
            payername
          }
        });
        const newTokens = Array.from([...tokens]);
        newTokens[0] = {
          ...payerToken,
          ...refreshTokenResponse.data,
        };
        setB2BTokens(newTokens);
        delete error.config.headers['Authorization'];
        return await axiosWithToken({
          ...error.config,
          headers: {
            ...error.config.headers,
            authorization: "Bearer " + refreshTokenResponse.data.accessToken,
          }
        });
      } catch (error) {
        localStorage.removeItem("b2bTokens");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);
